const enum DeliveryType {
  UBER_DIRECT = 'UBER_DIRECT',
  DEFAULT = 'DEFAULT',
}

export default DeliveryType;
